module.exports = __webpack_public_path__ + "img/dpost_mobile.0d8295de.png";